import { GenIcon } from 'react-icons';
export const MdClickToPay = GenIcon({
    tag: 'svg',
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 20 21',
        fill: 'none',
    },
    child: [
        {
            tag: 'g',
            attr: {
                clipPath: 'url(#clip0_20159_24780)',
            },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.584 16.6423L13.4173 18.0923C12.6173 18.459 11.7423 18.7007 10.834 18.7923V17.109C11.4507 17.034 12.034 16.8757 12.584 16.6423ZM3.39232 11.334H1.70898C1.80065 12.2507 2.04232 13.1173 2.40898 13.9173L3.85898 13.084C3.62565 12.534 3.46732 11.9507 3.39232 11.334ZM12.584 4.35898L13.4173 2.90898C12.6173 2.54232 11.7507 2.30065 10.834 2.20898V3.89232C11.4507 3.96732 12.034 4.12565 12.584 4.35898ZM16.609 9.66732H18.2923C18.2007 8.75065 17.959 7.88398 17.5923 7.08398L16.1423 7.91732C16.3757 8.46732 16.534 9.05065 16.609 9.66732ZM7.41732 16.6423L6.58398 18.0923C7.38398 18.459 8.25898 18.7007 9.16732 18.7923V17.109C8.55065 17.034 7.96732 16.8757 7.41732 16.6423ZM9.16732 3.89232V2.20898C8.25065 2.30065 7.38398 2.54232 6.58398 2.90898L7.41732 4.35898C7.96732 4.12565 8.55065 3.96732 9.16732 3.89232ZM15.3007 6.47565L16.7507 5.63398C16.2257 4.90898 15.584 4.26732 14.859 3.74232L14.0173 5.19232C14.509 5.56732 14.934 5.99232 15.3007 6.47565ZM3.85898 7.91732L2.40898 7.08398C2.04232 7.88398 1.80065 8.75065 1.70898 9.66732H3.39232C3.46732 9.05065 3.62565 8.46732 3.85898 7.91732ZM16.609 11.334C16.534 11.9507 16.3757 12.534 16.1423 13.084L17.5923 13.9173C17.959 13.1173 18.2007 12.2423 18.2923 11.334H16.609ZM14.0257 15.8007L14.8673 17.2507C15.5923 16.7257 16.234 16.084 16.759 15.359L15.309 14.5173C14.934 15.009 14.509 15.434 14.0257 15.8007ZM5.97565 5.20065L5.14232 3.74232C4.40898 4.27565 3.77565 4.90898 3.25065 5.64232L4.70065 6.48398C5.06732 5.99232 5.49232 5.56732 5.97565 5.20065ZM4.70065 14.5257L3.25065 15.359C3.77565 16.084 4.41732 16.7257 5.14232 17.2507L5.98398 15.8007C5.49232 15.434 5.06732 15.009 4.70065 14.5257ZM10.834 6.33398H9.16732V10.8423L12.7423 14.4173L13.9173 13.2423L10.834 10.159V6.33398Z',
                        fill: 'currentColor',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_20159_24780' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '20',
                                height: '20',
                                fill: 'white',
                                transform: 'translate(0 0.5)',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
